import { createFileRoute } from '@tanstack/react-router';
import { SnapshotsPane } from '@/components/health-readiness/panes';

/** Health & Readiness → Snapshots & trend (T-0242). T-0244 redraws it. */
export const Route = createFileRoute('/engagements/$engagementId/health-readiness/snapshots')({
  component: SnapshotsRoute,
});

function SnapshotsRoute() {
  const { engagementId } = Route.useParams();
  return <SnapshotsPane engagementId={engagementId} />;
}
